export const CACHE_TTL = import.meta.env.DEV ? 30 * 1000 : 5 * 60 * 1000
